import { DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import { MediaMatcher } from '@angular/cdk/layout';
import { ChangeDetectorRef, Component, HostBinding, Inject, OnDestroy, ViewChild, ViewEncapsulation } from '@angular/core';
import { userRoutes } from '../user-routing.module';
import { Event, NavigationEnd, NavigationStart, Router } from '@angular/router';
import { SidenavService } from './sidenav.service';
import { MatSidenav } from '@angular/material/sidenav';
import { trigger, transition, useAnimation } from '@angular/animations';
import { swing } from 'ng-animate';
import { DialogInitService } from '../services/dialog.service';
import { NotificacionesDialogComponent } from './notificaciones/notificaciones.component';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { TranslocoService } from '@ngneat/transloco';
import { ChangeTheme } from '../services/changeTheme.service';
import { OverlayContainer } from '@angular/cdk/overlay';

/** @title Responsive sidenav */

let dialogWidth;
let dialogHeight;
if (screen.width < 800) {
  dialogWidth = '100vh';
  dialogHeight = '100vw';
} else {
  dialogWidth = '80vh';
  dialogHeight = '80vh';
}

@Component({
  selector: 'sidenav',
  templateUrl: 'sidenav.component.html',
  styleUrls: ['sidenav.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [SidenavService],
  animations: [
    trigger('swing', [transition('* => *', useAnimation(swing))])
  ],
})
export class SidenavComponent implements OnDestroy {
  @HostBinding('class') componentCssClass: any;
  mobileQuery: MediaQueryList;
  userRoutes = userRoutes;
  isAdminSidebarExpanded: Boolean = false;
  swing: any;
  nameURL;
  nameURLs;
  notificacion = null;
  noLeidasUser: number = 0; //notificaciones no leidas
  noLeidasAdmin: number = 0; //notificaciones no leidas admin 
  subscriber: Subscription;
  checkLoad = false;
  activeLanguage: string;
  nametheme: string;
  descprov = localStorage.getItem('descprov');
  userppc = localStorage.getItem('userppc');
  idimagenemp = localStorage.getItem('idimagenemp');
  @ViewChild('sidenav', { static: false }) sidenav: MatSidenav;
  private _mobileQueryListener: () => void;
  spinner: boolean;

  constructor(changeDetectorRef: ChangeDetectorRef, media: MediaMatcher,
    public router: Router,
    public dialogInitService: DialogInitService,
    public sidenavService: SidenavService,
    public translateService: TranslocoService,
    public adapter: DateAdapter<any>,
    @Inject(MAT_DATE_LOCALE) private locale: string,
    public overlayContainer: OverlayContainer,
    changetheme: ChangeTheme
  ) {

    this.mobileQuery = media.matchMedia('(max-width: 600px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);

    this.router.events.subscribe((event: Event) => {      
      this.descprov = localStorage.getItem('descprov');
      this.userppc = localStorage.getItem('userppc');
      this.idimagenemp = localStorage.getItem('idimagenemp');
      this.nameURL = event['url'];
      this.nameURLs = this.nameURL?.slice(0, 10)
      if (this.nameURL === '/login' || this.nameURL === '/' || this.nameURLs === '/verificar') {
        this.sidenav.close();
      } else {
        this.sidenav.open();
      }

      if (window.screen.width < 700) {
        if (event instanceof NavigationStart) {
          this.sidenav.close();
        }
        else if (event instanceof NavigationEnd) {
          this.sidenav.close();
        }
      }
    });

    changetheme.changeEmitted$.subscribe(data => {
      this.onSetTheme(data);
    })
  }

  ngOnInit() {
    this.checkLoad = true;

    if (localStorage.getItem('activeLanguage')) {
      this.translateService.setActiveLang(localStorage.getItem('activeLanguage'))
    }
    if (localStorage.getItem('theme')) {
      this.onSetTheme(localStorage.getItem('theme'));
    }
    this.generarTraducciones();
  }

  //change theme
  public onSetTheme(e: string) {
    if (e == 'dark-theme') {
      this.overlayContainer.getContainerElement().classList.remove('light-theme');
      this.overlayContainer.getContainerElement().classList.add('dark-theme');
    } else {
      this.overlayContainer.getContainerElement().classList.remove('dark-theme');
      this.overlayContainer.getContainerElement().classList.add('light-theme');
    }
    this.componentCssClass = e;
  }


  openNotification(): void {
    this.dialogInitService.dialogInit(NotificacionesDialogComponent, 1, dialogHeight, dialogWidth).
      afterClosed().subscribe(result => { this.dialogCleanup(); });
  }

  dialogCleanup(): void { }

  toggleAdminSidebar() {
    return this.isAdminSidebarExpanded = !this.isAdminSidebarExpanded;
  }

  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }

  logout() {
    this.router.navigate(['/login']);
    this.sidenav.close();
    localStorage.removeItem('currentUser');
    localStorage.clear();
  }

  updateLangEs() {
    localStorage.setItem('activeLanguage', 'es');
    this.translateService.setActiveLang('es');
  }

  updateLangEn() {
    localStorage.setItem('activeLanguage', 'en');
    this.translateService.setActiveLang('en');
  }

  generarTraducciones() {
    this.translateService.langChanges$.subscribe(lang => {
      if (lang == 'en') {
        this.locale = 'en';
        this.adapter.setLocale(this.locale);
      } else {
        this.locale = 'es-AR';
        this.adapter.setLocale(this.locale);
      }
    });
  }
  shouldRun = [/(^|\.)plnkr\.co$/, /(^|\.)stackblitz\.io$/].some(h => h.test(window.location.host));
}



/**  Copyright 2020 Google LLC. All Rights Reserved.
    Use of this source code is governed by an MIT-style license that
    can be found in the LICENSE file at http://angular.io/license */